import React, { createContext } from 'react'

export interface FormContextValue {
    getFieldDecorator: (field: string, options?: any) => (node: any) => any
    getFieldValue: (field: string) => any
    setFieldValue: (key: string, value: any) => void
}

export const FormContext = createContext<FormContextValue>(null)

export const withFormContext = <P extends {}>(Component: React.ComponentType<P & FormContextValue>) => (props: P) =>
    React.createElement(FormContext.Consumer, null, (ctx: FormContextValue) =>
        React.createElement(Component, Object.assign({}, props, ctx) as any)
    )
